import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Search } from 'lucide-react';
import classes from "./RepaymentSchedule.module.css"
import plus from "../../../Assets/plus.svg"
import { FiPlus } from "react-icons/fi"; 
import download from "../../../Assets/download1.svg"
import upload from "../../../Assets/upload.svg"
import EyeIcon from "../../../Assets/new-eye.svg"
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form,Row, Col } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import HeaderNav from "../../Accoungting/HeaderNav/HeaderNav";
import axios from "axios";
import { BASE_URL } from "../../../Components/Styles/API/API";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import Swal from "sweetalert2";
import { FiDownload } from 'react-icons/fi';
import logo from "../../../Assets/rotating-logo.png";




const RepaymentSchedule = () => {
  const [fullName, setFullName] = useState("");
    const [createLoadings, setCreateLoadings] = useState(false);
    const [selectedDate, setSelectedDate] = useState('');
    const [selectOptions, setSelectOptions] = useState([]);
   const [createLoading, setCreateLoading] = useState(false);
   const [uploadLoading, setUploadLoading] = useState(false);
  const [fullName1, setFullName1] = useState("");
  const [email, setEmail] = useState("");
    const [selectedDate2, setSelectedDate2] = useState('');
  const [email1, setEmail1] = useState("");
  const [phone1, setPhone1] = useState("");
  const [phone, setPhone] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [address, setAddress] = useState("");
  const [office_address, setOfficeAddress] = useState("");
  const [accName, setAccName] = useState('');
  const [accNo, setAccNo] = useState('');
  const [bankName, setBankName] = useState('');
  const [accName1, setAccName1] = useState('');
  const [accNo1, setAccNo1] = useState('');
  const [bankName1, setBankName1] = useState('');
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [bearer, setBearer] = useState('');
  const [user, setUser] = useState('');
  const [error, setError] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState("");
  const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();
  const [benLoading, setBenLoading] = useState(false);
  const [statLoading, setStatLoading] = useState(false);
  const [show56, setShow56] = useState(false);
  const [stat, setStat] = useState([]);
  const [searchedResult, setSearchedResult] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [showEdit, setShowEdit] = useState(false);
const [editCustomer, setEditCustomer] = useState(null);
  const [selectedBank, setSelectedBank] = useState(null);
  const [duration, setDuration] = useState('');
  const [selectedLoan, setSelectedLoan] = useState(null);
  const [principalAmount, setPrincipalAmount] = useState('');
  const [loanInterest, setLoanInterest] = useState(0.00);
  const [interest, setInterest] = useState(0.00);
  const [totalRepayment, setTotalRepayment] = useState(0.00);
  const [monthlyDeduction, setMonthlyDeduction] = useState('');
    const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
   const [loans, setLoans] = useState([]);
  const [banks, setBanks] = useState([]);
   const [showModal, setShowModal] = useState(false);
  const [provinceID, setProvinceID] = useState("");
  const [showModal1,setShowModal1] = useState("")
  const [provinceId,setProvinceId] = useState("")
  const handleOpenModal1 = () => setShowModal1(true);
  const handleCloseModal1 = () => setShowModal1(false);
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const handleClose56 = () => setShow56(false);
    const handleShow56 = () => setShow56(true);
     const handleClose561 = () => setShow561(false);
  const [show561, setShow561] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);

const handlePrintAll = async () => {
  // 1. Prevent double clicking
  if (isPrinting) return;
  setIsPrinting(true);

  // Store the current data so we can restore it later
  const originalData = [...tableData];

  try {
    // 2. Fetch ALL data
    // We request page 1, but we ask for 'totalEntries' number of items per page.
    // NOTE: If your API uses 'limit' instead of 'per_page', change it below.
    const response = await axios.get(
      `${BASE_URL}/account/fetch-staff-loan?page=1&per_page=${totalEntries}`, 
      { headers }
    );
    
    const allResults = response.data?.data?.data;

    if (allResults && allResults.length > 0) {
      // 3. Update the table state to show ALL rows
      setTableData(allResults);

      // 4. Wait for React to render the new big table, then Print
      setTimeout(() => {
        window.print();
        
        // 5. Optional: Restore the original paginated data after printing
        // (Uncomment the line below if you want to switch back immediately)
        // setTableData(originalData); 
        
        setIsPrinting(false);
      }, 1000); // 1 second delay to ensure the DOM is fully updated
    }
  } catch (error) {
    console.error("Error fetching all data for print:", error);
    // Restore data if error occurs
    setTableData(originalData);
    setIsPrinting(false);
  }
};
  const handleShow561 = () => setShow561(true);
    

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const value2 = await localStorage.getItem('provinceID');
      const current = await localStorage.getItem('currentMonth');

      if (value !== null) {
        setBearer(value);
      }
      if (value1 !== null) {
        setUser(value1);
      }
      if (value2 !== null) {
        setProvinceId(value2);
      }

      if (current !== null) {
        console.log(current);
        const date = new Date(current);
      
        const startOfDateRange = new Date(1900, 0, 1);
     
        const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      
        // Format date function as 'YYYY-MM-DD'
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0'); 
          const day = String(date.getDate()).padStart(2, '0');     
          return `${year}-${month}-${day}`;
        };
      
        setMinDate(formatDate(startOfDateRange));
        setMaxDate(formatDate(endOfDateRange));
      
        console.log("Date Range:", formatDate(startOfDateRange), "to", formatDate(endOfDateRange));
      }


    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };


  const handleClose1 = () => setShow1(false);
  const handleClose2 = () => setShow2(false);

const handleShowEdit = (customer) => {
  setEditCustomer(customer); // load selected customer
  setShowEdit(true);
};

const handleCloseEdit = () => {
  setShowEdit(false);
  setEditCustomer(null);
};
   const handleShow = () => setShow(true);
const handleShow2 = (customer) => {
  setSelectedCustomer(customer); // save selected customer
  setShow2(true); // open modal
};
  const handleShow1 = () => setShow1(true);
  const handleClose = () => setShow(false);

 const fetchBooking = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account/fetch-staff-loan?page=${currentPage}`, { headers });
      const results = response.data?.data?.data;
      const resultx = response.data?.data?.total;
      setTotalEntries(resultx);
      setTableData(results);
      console.log(response);
      const total = response.data?.data?.last_page || 1;
      setTotalPages(total);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        const errorStatus = error.response?.data?.message;
        console.log(error);
        setTableData([]);
      }
    } finally {
      setIsLoading(false);
    }
  };

   useEffect(() => {
    if (bearer) {
      fetchBooking();

    }
  }, [bearer, currentPage]);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  const handlePrevPage = () => {
    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
  };

  const formattedTotalEntries = totalEntries.toLocaleString();

  const fetchStat = async () => {
    setStatLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer/total-customers`, { headers });
      const stas = response.data?.data;

      setStat(stas);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            console.log(errorMessage);
          }
        }
        setStat([]);
      }
    } finally {
      setStatLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchStat();

    }
  }, [bearer]);

  const formatStat = (value) => {
    if (value == null) return "";

    if (value >= 1000 && value < 1000000) {
      const rounded = value / 1000;
      // If divisible by 1000 exactly, no decimals (30k)
      if (value % 1000 === 0) {
        return `${rounded}k`;
      }
      // Else show 2 decimals (30.01k)
      return `${rounded.toFixed(2)}k`;
    }

    if (value >= 1000000) {
      const rounded = value / 1000000;
      if (value % 1000000 === 0) {
        return `${rounded}M`;
      }
      return `${rounded.toFixed(2)}M`;
    }

    // smaller than 1000 → just locale string with commas
    return value.toLocaleString("en-US");
  };

  const fetchSearch = async (searchTerm) => {
    setSearchLoading(true);
    try {
      let res;
      if (searchTerm.trim() === "") {
        res = tableData;
      } else {
        const response = await axios.get(`${BASE_URL}/customer/search`, {
          params: { variable: searchTerm },
          headers
        });
        res = response.data?.data;
      }
      setSearchedResult(res);
      console.log(res, "searched");

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setSearchedResult([]);
      }
    } finally {
      setSearchLoading(false);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      if (searchTerm.trim() !== "") {
        fetchSearch(searchTerm);
      } else {
        setSearchedResult([]); // clear results if empty
      }
    }, 500); // 500ms debounce

    return () => {
      clearTimeout(handler); // cancel on new keystroke
    };
  }, [searchTerm]);

  const isSearching = searchTerm.trim() !== "" && searchedResult.length > 0;


   const handleFileChange = (event) => {
    const files = event.target.files;
    const fileList = Array.from(files);
    setSelectedFile(fileList);
    
  };
   const uploadExcel = async () => {
    setUploadLoading(true);
      try {
        const formData = new FormData();
      formData.append('file', selectedFile[0]);
      formData.append('loan_code', selectedLoan);
      formData.append('transaction_date', selectedDate2);
     
      // console.log(selectedFile);
  
      const headers = {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${bearer}`,
      };
  
      const response = await axios.post(`${BASE_URL}/customer/upload_loan_excel`,
        formData,
        { headers }
      );
  handleClose56();
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
  
      console.log(response.data.message);
    } catch (error) {
      const errorStatus = error?.response?.data?.message;
  
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: errorStatus,
      });
  
      console.error(error);
    } finally {
      setUploadLoading(false);
      }
    };


  const downloadTemplate = async () => {
    setLoading(true);

    try {
      const response = await axios.get(
        // `${BASE_URL}/download_loan_repayment_excel?loan_code=selectedLoan&province_id=provinceID`,
        `${BASE_URL}/download_loan_repayment_excel?loan_code=${selectedLoan}&province_id=${provinceId}`,
        { headers }
      );
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Download Complete',
      });

      window.location.href = `${BASE_URL}/download_loan_repayment_excel?loan_code=${selectedLoan}&province_id=${provinceId}`;
      console.log(response.data);
    } catch (error) {
      let errorMessage;

      if (error.response && error.response.data) {
        errorMessage = typeof error.response.data.message === 'object'
          ? JSON.stringify(error.response.data.message)
          : error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      } else {
        errorMessage = 'An unexpected error occurred while uploading the file';
      }

      // const errorStatus = error.response?.data?.message || 'An error occurred';

      Swal.fire({
        icon: 'error',
        title: 'Failed',
        // text: errorStatus,
        text: errorMessage,
      });

      console.error(error);
    } finally {
      setLoading(false);
    }
  };

   const createLoan = async () => {
    setCreateLoading(true);
    try {
      const parsedMonthlyDeduction = monthlyDeduction === '' ? 0 : monthlyDeduction || 0;
      const response = await axios.post(
        `${BASE_URL}/account/staff-loan`,
        {
          member_name: selectedCustomer || '',
          loan_name: selectedLoan || '',
          bank: selectedBank.value,
          principal_amount: principalAmount,
          interest_amount: interest,
          total_repayment: totalRepayment,
          monthly_deduction: parsedMonthlyDeduction,
          loan_interest: loanInterest,
          duration: duration,
          transaction_date: selectedDate,
          // cheque_number: cheque


        },
        { headers }
      );
      console.log(response.data.message)
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });

      setSelectedCustomer(null);
      setSelectedLoan(null);
      setSelectedBank(null);
      setSelectedDate('');
      setSelectedDate('');
      setPrincipalAmount('');
      setLoanInterest('');
      setInterest('');
      setTotalRepayment('');
      setDuration('');
      setMonthlyDeduction('');

    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          console.log(error.response.data.message);
        }
      }
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: JSON.stringify(error.response.data.data),
      });
    } finally {
      setCreateLoading(false);
    }
  };

  const handleBankChange = (selectedOption) => {
    setSelectedBank(selectedOption);
  }

  const handleValueChange = (value, name, values) => {
    setPrincipalAmount(value);
  };

  const handleValueChange1 = (value, name, values) => {
    setLoanInterest(value);
  };

  const handleValueChange2 = (value, name, values) => {
    setInterest(value);
  };

  const handleValueChange3 = (value, name, values) => {
    setTotalRepayment(value);
  };

  const handleValueChange4 = (value, name, values) => {
    setMonthlyDeduction(value);
  };

      const handleDateChange = (event) => {
        // setSelectedDate(event.target.value);
  const newDate = event.target.value;

  // Ensure minDate and maxDate are set
  if (!minDate || !maxDate) return;

  // Block if outside range
  if (newDate < minDate || newDate > maxDate) {
    alert(`Please select a date between ${minDate} and ${maxDate}`);
    return;
  }

  setSelectedDate(newDate);
};

  const handleDateChange2 = (event) => {
    setSelectedDate2(event.target.value);
  };
  const handleSupplierChange = (selectedOption) => {
    setSelectedCustomer(selectedOption.value);
  }

  const handleLoanTypeChange = (selectedOption) => {
    setSelectedLoan(selectedOption.value);
    const selectedLoanInterest = selectedOption.interest;
    setLoanInterest(selectedLoanInterest === null ? "0.00" : selectedLoanInterest);
  }

    const fetchSupplierss = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer/loan-customers-select`, { headers });
      console.log(response)
      // const response = await axios.get(`${BASE_URL}/customer/no-pagination`, { headers });
      // const results = response.data?.data?.data;
      const results = response.data?.data || [];
      console.log("results:", results)
      const options = results.map((item) => ({
        label: item.name,
        value: item.id,
      }));
  
      setSelectOptions(options);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
    
    } finally {
      setIsLoading(false);
    }
  };


  const fetchLoans = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account/fetch-loans`, { headers });
      const results = response.data?.data;

      const options1 = results.map((item) => ({
        label: item.description,
        value: item.id,
        interest: item.interest
      }));
      setLoans(options1);
      // setSelectOptions(options);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchBanks = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account/bank-accounts`, { headers });
      const results = response.data?.data;

      const options1 = results.map((item) => ({
        label: item.gl_name,
        value: item.id,
      }));
      setBanks(options1);
      // setSelectOptions(options);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setBanks([]);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (bearer) {
      fetchSupplierss();
      fetchLoans();
      fetchBanks();
    }
  }, [bearer]);

  return (
    <div >
  <Modal
  show={showModal}
  onHide={handleCloseModal}
  size="md"
  centered
  scrollable
  // backdrop="static"
>
  <Modal.Header closeButton>
    <Modal.Title className="h5">
      Create New Loan
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <Form>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
        
        {/* Transaction Date */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ marginBottom: '6px', fontWeight: 500 }}>Transaction Date</label>
          <input
            className="form-control"
            required
            type="date"
            onChange={handleDateChange}
            min={minDate}
            max={maxDate}
            name="date"
            value={selectedDate}
          />
        </div>

        {/* Member */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ marginBottom: '6px', fontWeight: 500 }}>Member</label>
          <Select
            onChange={(selectedOption) => handleSupplierChange(selectedOption)}
            options={selectOptions}
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              menu: (provided) => ({ ...provided, maxHeight: '300px', overflowY: 'auto' }),
            }}
          />
        </div>

        {/* Loan Type */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ marginBottom: '6px', fontWeight: 500 }}>Loan Type</label>
          <Select
            onChange={(selectedOption) => handleLoanTypeChange(selectedOption)}
            options={loans}
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              menu: (provided) => ({ ...provided, maxHeight: '200px', overflowY: 'auto' }),
            }}
          />
        </div>

        {/* Principal Amount */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ marginBottom: '6px', fontWeight: 500 }}>Principal Amount</label>
          <CurrencyInput
            name="principal amount"
            decimalsLimit={2}
            className="form-control"
            value={principalAmount}
            onValueChange={handleValueChange}
            style={{ textAlign: "right" }}
          />
        </div>

        {/* Loan Interest */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ marginBottom: '6px', fontWeight: 500 }}>Loan Interest</label>
          <CurrencyInput
            name="loan interest"
            decimalsLimit={2}
            className="form-control"
            value={loanInterest}
            disabled
            onValueChange={handleValueChange1}
            style={{ textAlign: "right" }}
          />
        </div>

        {/* Interest */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ marginBottom: '6px', fontWeight: 500 }}>Interest</label>
          <CurrencyInput
            name="loan interest"
            decimalsLimit={2}
            className="form-control"
            value={interest}
            disabled
            onValueChange={handleValueChange2}
            style={{ textAlign: "right" }}
          />
        </div>

        {/* Total Repayment */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ marginBottom: '6px', fontWeight: 500 }}>Total Repayment</label>
          <CurrencyInput
            name="loan interest"
            decimalsLimit={2}
            className="form-control"
            value={totalRepayment}
            disabled
            onValueChange={handleValueChange3}
            style={{ textAlign: "right" }}
          />
        </div>

        {/* Duration */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ marginBottom: '6px', fontWeight: 500 }}>Duration (Months)</label>
          <input
            className="form-control"
            required
            type="text"
            onChange={(e) => setDuration(e.target.value)}
            name="duration"
            value={duration}
          />
        </div>

        {/* Monthly Deduction */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ marginBottom: '6px', fontWeight: 500 }}>Monthly Deduction</label>
          <CurrencyInput
            name="loan interest"
            decimalsLimit={2}
            className="form-control"
            value={monthlyDeduction}
            disabled
            onValueChange={handleValueChange4}
            style={{ textAlign: "right" }}
          />
        </div>

        {/* Select Bank */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ marginBottom: '6px', fontWeight: 500 }}>Select Bank</label>
          <Select
            value={selectedBank}
            onChange={(selectedOption) => handleBankChange(selectedOption)}
            options={banks}
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              menu: (provided) => ({ ...provided, maxHeight: '200px', overflowY: 'auto' }),
            }}
          />
        </div>

      </div>
    </Form>
  </Modal.Body>

  <Modal.Footer>
    <Button onClick={createLoan} className={classes.loanBtn}>
      {createLoading ? (
        <>
          <Spinner size='sm' />
          <span style={{ marginLeft: '5px' }}>Creating, Please wait...</span>
        </>
      ) : (
        "Create New Loan"
      )}
    </Button>
  </Modal.Footer>
</Modal>

   <Modal show={show561} onHide={handleClose561} animation={false}>
                      <Modal.Header closeButton>
                        <Modal.Title className="h5">Repayment Schedule Template</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form style={{ marginTop: 10 }}>
                          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Select Loan Type</Form.Label>
                            <Select
                          // value={selectedLoan}
                          onChange={(selectedOption) => handleLoanTypeChange(selectedOption)}
                          options={loans}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            menu: (provided) => ({
                              ...provided,
                              maxHeight: '600px',
                              overflowY: 'auto',
                            }),
                          }}
                        />
                          </Form.Group>
                        </Form>
                      </Modal.Body>
                      <Modal.Footer>
                        
                        <Button variant="light" onClick={handleClose561}>
                          Go back
                        </Button>
                        {/* <a href="https://account-api.patna.ng/api/v1/download_loan_repayment_excel?loan_code=${selectedLoan}&province_id=${provinceID}" download> */}
                        <Button  onClick={downloadTemplate} className={classes.loanBtn}>
                          {loading ? (
                            <>
                              <Spinner size='sm' />
                              <span style={{ marginLeft: '5px' }}>Downloading, please wait...</span>
                            </>
                          ) : (
                            "Download Template"
                          )}
                        </Button>
                        {/* </a> */}
                      </Modal.Footer>
                    </Modal>

                      <Modal show={show56} onHide={handleClose56} animation={false}>
                      <Modal.Header closeButton>
                        <Modal.Title className="h6">Upload Repayment Schedule</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form style={{ marginTop: 20 }}>
                          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Transaction Date</Form.Label>
                            <Form.Control
                              type="date"
                              onChange={handleDateChange2} 
                              value={selectedDate2}
                              min={minDate}
                              max={maxDate}
                            />
                          </Form.Group>
                          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Loan Type</Form.Label>
                            <Select
                          // value={selectedLoan}
                          onChange={(selectedOption) => handleLoanTypeChange(selectedOption)}
                          options={loans}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            menu: (provided) => ({
                              ...provided,
                              maxHeight: '400px',
                              overflowY: 'auto',
                            }),
                          }}
                        />
                          </Form.Group>
                          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Upload Excel File</Form.Label>
                            <Form.Control
                              type="file"
                              accept=".xlsx, .xls, .csv"
                              onChange={handleFileChange}
                            />
                          </Form.Group>
                        </Form>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="light" onClick={handleClose56}>
                          Go back
                        </Button>
                        <Button variant="success" onClick={uploadExcel} className={classes.loanBtn}>
                          {uploadLoading ? (
                            <>
                              <Spinner size='sm' />
                              <span style={{ marginLeft: '5px' }}>Uploading, Please wait...</span>
                            </>
                          ) : (
                            "Upload"
                          )}
                        </Button>
                      </Modal.Footer>
                    </Modal>

<Modal
   show={showModal1}
  onHide={handleCloseModal1}
  size="md"
  centered
  backdrop="static"
  scrollable 
>
  <Modal.Header closeButton>
    <Modal.Title className="h6">
      View Loan & Advance
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <Form>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>

        {/* Transaction Date */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ fontWeight: 500 }}>Transaction Date</label>
          <input
            className="form-control"
            type="date"
            required
            value={selectedLoan?.transaction_date}
            disabled
          />
        </div>

        {/* Member */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ fontWeight: 500 }}>Member</label>
          <input
            className="form-control"
            type="text"
            required
            value={selectedLoan?.beneficiary?.name}
            disabled
          />
        </div>

        {/* Loan Type */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ fontWeight: 500 }}>Loan Type</label>
          <input
            className="form-control"
            type="text"
            required
            value={selectedLoan?.loan?.description}
            disabled
          />
        </div>

        {/* Principal Amount */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ fontWeight: 500 }}>Principal Amount</label>
          <CurrencyInput
            className="form-control"
            value={selectedLoan?.principal_amount}
            decimalsLimit={2}
            disabled
            style={{ textAlign: 'right' }}
          />
        </div>

        {/* Loan Interest */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ fontWeight: 500 }}>Loan Interest</label>
          <CurrencyInput
            className="form-control"
            value={selectedLoan?.loan_interest}
            decimalsLimit={2}
            disabled
            style={{ textAlign: 'right' }}
          />
        </div>

        {/* Interest */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ fontWeight: 500 }}>Interest</label>
          <CurrencyInput
            className="form-control"
            value={selectedLoan?.interest_amount}
            decimalsLimit={2}
            disabled
            style={{ textAlign: 'right' }}
          />
        </div>

        {/* Total Repayment */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ fontWeight: 500 }}>Total Repayment</label>
          <CurrencyInput
            className="form-control"
            value={selectedLoan?.total_repayment}
            decimalsLimit={2}
            disabled
            style={{ textAlign: 'right' }}
          />
        </div>

        {/* Duration */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ fontWeight: 500 }}>Duration (Months)</label>
          <input
            className="form-control"
            type="text"
            required
            value={selectedLoan?.duration}
            disabled
          />
        </div>

        {/* Monthly Deduction */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ fontWeight: 500 }}>Monthly Deduction</label>
          <CurrencyInput
            className="form-control"
            value={selectedLoan?.monthly_deduction}
            decimalsLimit={2}
            disabled
            style={{ textAlign: 'right' }}
          />
        </div>

        {/* Select Bank */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ fontWeight: 500 }}>Select Bank</label>
          <Select
            value={selectedBank}
            onChange={handleBankChange}
            options={banks}
            isDisabled
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              menu: (provided) => ({ ...provided, maxHeight: '200px', overflowY: 'auto' }),
            }}
          />
        </div>

        {/* Cheque Number */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ fontWeight: 500 }}>Cheque No.</label>
          <input
            className="form-control"
            type="text"
            required
            value={selectedLoan?.cheque_number}
            disabled
          />
        </div>

      </div>
    </Form>
  </Modal.Body>

  <Modal.Footer style={{ gap: '12px' }}>


    <Button variant="light">
      {createLoadings ? (
        <>
          <Spinner size="sm" />
          <span style={{ marginLeft: '5px' }}>Processing, Please wait...</span>
        </>
      ) : (
        'Disapprove Loan'
      )}
    </Button>
        <Button variant="success" onClick={createLoan} className={classes.loanBtn}>
      {createLoading ? (
        <>
          <Spinner size="sm" />
          <span style={{ marginLeft: '5px' }}>Processing, Please wait...</span>
        </>
      ) : (
        'Approve Loan'
      )}
    </Button>
  </Modal.Footer>
</Modal>


      <HeaderNav />

      <div className={classes.topContainer}>
        <div className={classes.topNavBars}>
          <Button className={classes.buttonsNav}>Remitances</Button>
          <Button className={classes.buttonsNav}>Petty Cash</Button>
          <Button className={classes.buttonsNav}>Supplier's Payment</Button>
          <Button className={classes.buttonsNav}>Customer's Leger</Button>
        </div>
        <div style={{ marginTop: 24 }} />
        <h3 className={classes.topText}>Repayment Schedule</h3>
        <p className={classes.prgText}>View, Create, and Edit Loan Repayment Schedule</p>
      <Row style={{ marginTop: 16 }}>
  <Col md={3}>
    <div className={classes.thrdkad}>
      <p className={classes.kdptg}>Total Loan Repayment</p>
      <p className={classes.kdptg1}>₦0.00</p>
      <div className={classes.rvnue}>
        <p className={classes.skaltxt}>This month</p>
      </div>
    </div>
  </Col>
  <Col md={3}>
    <div className={classes.frtkad}>
      <div className={classes.kad}>
        <p className={classes.kdptg}>Completed</p>
        <p className={classes.kdptg2}>₦0.00</p>
        <div className={classes.rvnue}>
          <p className={classes.skaltxt}>Completed loan repayments</p>
        </div>
      </div>
    </div>
  </Col>
  <Col md={3}>
    <div className={classes.fiftkad}>
      <div className={classes.kad}>
        <p className={classes.kdptg}>Overdue</p>
        <p className={classes.kdptg3}>₦0.00</p>
        <div className={classes.rvnue}>
          <p className={classes.skaltxt}>Overdue loan repayments</p>
        </div>
      </div>
    </div>
  </Col>
  <Col md={3}>
    <div className={classes.frstkad}>
      <div className={classes.kad}>
        <p className={classes.kdptg}>Pending</p>
        <p className={classes.kdptg4}>₦0.00</p>
        <div className={classes.rvnue}>
          <p className={classes.skaltxt}>Pending loan repayments</p>
        </div>
      </div>
    </div>
  </Col>
</Row>

        <div className={classes.subContainer}>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            gap: 16,
            alignItems: 'center'
          }}>
            <div className={classes.searchInputWrapper}>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className={classes.searchInput}
                placeholder="Search schedule..."
              />
              {searchTerm ? (
                <button
                  onClick={() => {
                    setSearchTerm("");
                    setSearchedResult([]);
                  }}
                  className={classes.clearBtn}
                >
                  ✕
                </button>
              ) : (
                <Search className={classes.searchIcon} size={16} />
              )}
            </div>
          </div>
          <div className={classes.threeBtns}>
            
            {/* <button className={classes.downBtn} onClick={handleOpenModal}>
             <FiPlus size={20} style={{ marginRight: 6 }} /> Create New Loan
            </button> */}
          

            <button className={classes.loanBtn} onClick={handleShow561}>
              <FiDownload size={20} style={{ color: 'white', marginRight: 6 }} />   Download Template
            </button>
                    
            <button className={classes.downBtn} onClick={handleShow56}>
              <img src={upload} alt="plus" /> Upload Payment Schedule
            </button>
           
          </div>

        </div>
        <div className={classes.tableContainer}>
          <table className={classes.tableTable}>
            <thead className={classes.tableHeader}>
              <tr>
                <th>S/N</th>
                <th>Date</th>
                <th>Staff Number</th>
                <th>Loan Name</th>
                <th style={{ textAlign: "right" }}>Balance</th>
                {/* <th>Created At</th> */}
                <th style={{ textAlign: "center" }}> Actions</th>
              </tr>
            </thead>
            <tbody>
              {benLoading ? (
                // Skeleton loading
                Array(5).fill().map((_, idx) => (
                  <tr key={idx}>
                    {Array(5).fill().map((_, i) => (
                      <td key={i}>
                        <Skeleton height={20} style={{ marginBottom: 10 }} />
                      </td>
                    ))}
                  </tr>
                ))
              ) : (isSearching ? (
                searchedResult.length === 0 ? (
                  <tr>
                    <td colSpan={7} style={{ textAlign: "center", color: "red" }}>
                      No matching customers found
                    </td>
                  </tr>
                ) : (

                  searchedResult.map((item, index) => (
                    <tr key={index}>
                      <td className={classes.textby}>{index + 1}</td>
                      <td className={classes.textby}>{item.employee_no}</td>
                      <td className={classes.textby}>{item.name}</td>
                      <td className={classes.textby}>{formatDate(item.created_at)}</td>
              
                      {/* <td className={classes.btnAction}>
                        <button
                          style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
                          onClick={() => handleShow2(item)}
                        >
                          <img src={EyeIcon} />
                        </button>
                        <button
                          style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
                          onClick={() => handleShowEdit(item)}
                        >
                          <img src={PencilIcon} />
                        </button>

                        <button
                          style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
                        >
                          <img src={DeleteIcon} />
                        </button>
                      </td> */}
                    </tr>
                  ))
                )
              ) : (
                // Default tableData
                tableData?.map((item, index) => (
                  <tr key={index} className={classes.textby}>
                    <td className={classes.textby} >{index + 1}</td>
                     <td className={classes.textby}>{item?.transaction_date}</td>
                     <td className={classes.textby}>{item?.beneficiary?.name}</td>
                                          <td className={classes.textby}>{item?.loan?.description}</td>
                     
                     <td style={{ textAlign: "right" }} className={classes.textby}>{parseFloat(item?.balance).toLocaleString('en-US', {
                                            minimumIntegerDigits: 1,
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                          })}</td>
                    
                    <td className={classes.btnAction} >
                      <button
                        style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
                        onClick={() => handleOpenModal1(item)}
                      >
                        <img src={EyeIcon} />
                      </button>

                      {/* <button
                        style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
                      >
                        <img src={DeleteIcon} />
                      </button> */}
                    </td>
                  </tr>
                ))
              ))}
            </tbody>

          </table>
          {!isSearching && (
            <div className={classes.paginationStyle}>
              <div className={classes.footerSubOne}>
                <button onClick={handlePrevPage}
                  disabled={currentPage === 1} className={classes.btnFirst}>Prev</button>
                {[...Array(totalPages)].map((_, page) => {
                  // Show only 5 pages or less if available
                  if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                    return (
                      <span key={page + 1} className={classes.ftOne}>
                        <button
                          className={`${classes.pageNumber} ${currentPage === page + 1 ? classes.active : ""}`}
                          onClick={() => setCurrentPage(page + 1)}
                        >
                          {page + 1}
                        </button>
                      </span>
                    );
                  }
                })}


                <button className={classes.btnSec} onClick={handleNextPage}
                  disabled={currentPage === totalPages}>Next</button>
              </div>
              <p className={classes.displayPag}>Displaying {`Page ${currentPage} - ${totalPages} pages`} of {formattedTotalEntries} entries</p>
            </div>
          )}


        </div>
      </div>
      {loading && (
        <div className={classes.overlay}>
          <img src={logo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}
      {uploading && (
        <div className={classes.overlay}>
          <img src={logo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}
    </div>
  )
}

export default RepaymentSchedule;